import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function hexToHslComponents(hex: string): string {
  let pureHex = hex.replace(/^#/, '');

  // Handle 3-digit hex
  if (pureHex.length === 3) {
    pureHex = pureHex.split('').map(char => char + char).join('');
  }

  // Parse r, g, b
  const r = Number.parseInt(pureHex.substring(0, 2), 16) / 255;
  const g = Number.parseInt(pureHex.substring(2, 4), 16) / 255;
  const b = Number.parseInt(pureHex.substring(4, 6), 16) / 255;

  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);
  let h = 0;
  let s = 0;
  const l = (max + min) / 2;

  if (max !== min) {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch (max) {
      case r: h = (g - b) / d + (g < b ? 6 : 0); break;
      case g: h = (b - r) / d + 2; break;
      case b: h = (r - g) / d + 4; break;
    }
    h /= 6;
  }

  // Return components without hsl() wrapper, as expected by shadcn/tailwind
  return `${Math.round(h * 360)} ${Math.round(s * 100)}% ${Math.round(l * 100)}%`;
}

export function getContrastForeground(hex: string): string {
  let pureHex = hex.replace(/^#/, '');
  if (pureHex.length === 3) {
    pureHex = pureHex.split('').map(char => char + char).join('');
  }
  const r = Number.parseInt(pureHex.substring(0, 2), 16) / 255;
  const g = Number.parseInt(pureHex.substring(2, 4), 16) / 255;
  const b = Number.parseInt(pureHex.substring(4, 6), 16) / 255;
  // Relative luminance (WCAG formula)
  const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b;
  return luminance > 0.5 ? '0 0% 10%' : '0 0% 100%';
}
